export const validateAttestationDate = (lastAttestationDate, startDate) => value => {
  if (!value) return "Задължително";

  const baseDate = lastAttestationDate ?? startDate;
  if (!baseDate) return undefined;

  const minDate = new Date(baseDate);
  minDate.setDate(minDate.getDate() + 30);

  if (new Date(value) < minDate) {
    return `Датата трябва да е минимум 30 дни след последната заверка. Първа възможна дата: (${minDate.toLocaleDateString("bg-BG")})`;
  }
  return undefined;
};

export const getMinDate = (lastAttestationDate, startDate) => {
  const baseDate = lastAttestationDate ?? startDate;
  if (!baseDate) return null;
  const min = new Date(baseDate);
  min.setDate(min.getDate() + 30);
  return min.toLocaleDateString("bg-BG");
};
